import { render } from "./manage-sections-header.vue?vue&type=template&id=11d23037"
import script from "./manage-sections-header.vue?vue&type=script&lang=js"
export * from "./manage-sections-header.vue?vue&type=script&lang=js"

import "./manage-sections-header.vue?vue&type=style&index=0&id=11d23037&lang=scss"

import exportComponent from "C:\\Users\\yrabie\\Documents\\Projects\\Awsat Admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__